import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Card,
  Checkbox,
  Avatar,
  CardContent,
  Badge
} from '@mui/material';
import toast from 'react-hot-toast';

const BulkImageImportDialog = ({ open, onClose, libraryAsanas = [], onBulkSelect, maxSelect = Infinity }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const handleToggle = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds((prev) => prev.filter((x) => x !== id));
      return;
    }

    if (selectedIds.length >= maxSelect) {
      toast.error(`You can only select ${maxSelect} Asanas`, {
        style: {
          background: '#ff1100ff',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '16px',
          borderRadius: '5px'
        },
        iconTheme: {
          primary: '#fff',
          secondary: '#ff1100ff'
        }
      });
      return;
    }
    setSelectedIds((prev) => [...prev, id]);
  };

  const handleImport = () => {
    const selectedObjects = selectedIds.map((id) => libraryAsanas.find((a) => a.id === id));
    console.log('Selected asanas for bulk import:', selectedObjects); // Debug log
    onBulkSelect(selectedObjects);
    setSelectedIds([]); // Clear selection
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Select Asanas for Bulk Import</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Selected: {selectedIds.length}/{maxSelect}
        </Typography>
        <Grid container spacing={3}>
          {libraryAsanas
            .filter((asana) => Boolean(asana.image))
            .map((asana) => {
              const isSelected = selectedIds.includes(asana.id);
              const selectionOrder = isSelected ? selectedIds.indexOf(asana.id) + 1 : null;
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={asana.id}>
                  <Card
                    sx={{
                      position: 'relative',
                      cursor: 'pointer',
                      boxShadow: isSelected ? '0 0 0 2px #1976d2' : '0 1px 5px rgba(0,0,0,0.06)'
                    }}
                    onClick={() => handleToggle(asana.id)}
                  >
                    <Badge
                      badgeContent={selectionOrder}
                      color="primary"
                      invisible={!isSelected}
                      sx={{ position: 'absolute', top: 8, left: 8, zIndex: 2 }}
                    />
                    <Checkbox
                      checked={isSelected}
                      sx={{ position: 'absolute', top: 8, right: 8, zIndex: 2, background: 'white', borderRadius: 1 }}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => handleToggle(asana.id)}
                    />
                    <Avatar src={asana.image} alt={asana.name} variant="rounded" sx={{ width: '100%', height: 180, objectFit: 'cover' }} />
                    <CardContent>
                      <Typography variant="subtitle1" fontWeight={600}>
                        {asana.name}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={selectedIds.length === 0} onClick={handleImport}>
          Import Selected ({selectedIds.length})
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkImageImportDialog;
